import { SvgIconComponent } from '@material-ui/icons';
import ImageRoundedIcon from '@material-ui/icons/ImageRounded';
import InsertDriveFileRoundedIcon from '@material-ui/icons/InsertDriveFileRounded';
import VideocamRoundedIcon from '@material-ui/icons/VideocamRounded';

import { MidiasContatoEnum } from 'store/reducers/contatos';

export interface MediaTypeConfig {
  key: MidiasContatoEnum;
  title: string;
  icon: SvgIconComponent;
  colorKey: 'primary' | 'success' | 'warning';
}

export const MEDIA_TYPES: MediaTypeConfig[] = [
  {
    key: MidiasContatoEnum.DOCUMENTO,
    title: 'Documentos',
    icon: InsertDriveFileRoundedIcon,
    colorKey: 'primary',
  },
  {
    key: MidiasContatoEnum.VIDEO,
    title: 'Vídeos',
    icon: VideocamRoundedIcon,
    colorKey: 'success',
  },
  {
    key: MidiasContatoEnum.IMAGEM,
    title: 'Imagens',
    icon: ImageRoundedIcon,
    colorKey: 'warning',
  },
];

export const getMediaTypeConfig = (
  key: MidiasContatoEnum,
): MediaTypeConfig | undefined => {
  return MEDIA_TYPES.find(type => type.key === key);
};
